import { useCallback } from 'react';

const BUSINESS_PRODUCTS = [
  'PRODUCT_PRIME',
  'PRODUCT_UBO',
  'PRODUCT_EXCHANGE',
  'PRODUCT_INTL_EXCHANGE',
];

export function useGetIsBusinessUser() {
  /* FIXME: @mingshuo-zhang will remove this function, this is a short-term solution and we will rely on
      security check up endpoint to check
      return true if api call failed
   */
  return useCallback(async (): Promise<boolean> => {
    try {
      const res = await fetch(`${window.location.origin}/api/v1/user`);
      const body = await res.json();
      if (!body?.product_access) return true;

      const productAccess = body.product_access as string[];

      return productAccess.some((product) => BUSINESS_PRODUCTS.includes(product));
    } catch (e) {
      return true;
    }
  }, []);
}
